<script setup lang="ts">
import { CheckCircleIcon } from "@heroicons/vue/24/outline";
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";
import type { components } from "@/types/openapi.interfaces";

import CircleCheckMarkIcon from "@/components/icons/CircleCheckMarkIcon.vue";
import CircleXMarkIcon from "@/components/icons/CircleXMarkIcon.vue";
import ClockIcon from "@/components/icons/ClockIcon.vue";

const props = defineProps<{
  status: components["schemas"]["StatusEnum"];
  class?: string;
}>();
const { data: user } = useUser();
</script>

<template>
  <span
    :class="
      twMerge(
        'inline-flex w-fit items-center justify-center gap-3 rounded-lg border px-5 py-2 text-base leading-[110%] font-medium whitespace-nowrap lg:px-6 lg:py-3 lg:text-lg [&>svg]:size-5 lg:[&>svg]:size-8',
        user?.current_mechanic !== 'lactel' &&
          (status === 'declared' || status === 'user_reviewed') &&
          'border-galbani text-galbani bg-white',
        user?.current_mechanic !== 'lactel' &&
          status === 'completed' &&
          'bg-topchef border-topchef text-galbani',
        user?.current_mechanic !== 'lactel' &&
          status === 'filtered_analyzed' &&
          'border-success bg-success text-white',
        user?.current_mechanic === 'lactel' &&
          (status === 'declared' || status === 'user_reviewed') &&
          'border-lactel-blue text-lactel-blue bg-white',
        user?.current_mechanic === 'lactel' &&
          status === 'completed' &&
          'bg-lactel-yellow border-lactel-yellow text-lactel-blue',
        user?.current_mechanic === 'lactel' &&
          status === 'filtered_analyzed' &&
          'border-lactel-green-600 bg-lactel-green-600 text-white',
        status === 'rejected' && 'border-error bg-error text-white',
        props.class,
      )
    "
    role="status"
  >
    <template v-if="status === 'declared'">
      <ClockIcon aria-hidden="true" />

      <span>{{ $t("receipt.declared") }}</span>
    </template>

    <template v-if="status === 'user_reviewed'">
      <ClockIcon aria-hidden="true" />

      <span>{{ $t("receipt.inReview") }}</span>
    </template>

    <template v-if="status === 'completed'">
      <CircleCheckMarkIcon aria-hidden="true" />

      <span>{{ $t("receipt.completed") }}</span>
    </template>

    <template v-if="status === 'rejected'">
      <CircleXMarkIcon aria-hidden="true" />

      <span>{{ $t("receipt.rejected") }}</span>
    </template>

    <template v-if="status === 'filtered_analyzed'">
      <CheckCircleIcon aria-hidden="true" />

      <span>{{ $t("receipt.analyzed") }}</span>
    </template>
  </span>
</template>
